import { createContext, useContext } from "react";

const DockTabTitleContext = createContext<(title: string, tooltip?: string) => void>(() => {});

export const useDockTabTitle = () => useContext(DockTabTitleContext);

export default DockTabTitleContext;
